<template>
  <div
    ref="heroContainer"
    class="hero"
  >
    <!-- Hero -->
    <div
      ref="hero"
      class="hero__scene-container hero__scene-container--1"
    >
      <div class="scene scene--1 hero-scene">
        <video
          v-if="isDesktop"
          class="hero-scene__video"
          src="/theme/rbFront/img/w/mediaArtSolution/video/kv_pc.mp4"
          autoplay  
          loop      
          muted     
          playsinline 
          @loadedmetadata="handleLoadedVideo"
        />
        <video
          v-if="isMobile"
          class="hero-scene__video"
          src="/theme/rbFront/img/w/mediaArtSolution/video/kv_mo.mp4"
          autoplay  
          loop      
          muted     
          playsinline 
          @loadedmetadata="handleLoadedVideo"
        />
        <!-- :class="{ 'scale-to-normal': startVideo }" -->
        
        <!-- Scene 1 Text -->
        <div
          class="hero-scene__textbox1"
          :class="{
            'fade-up-in': currentScene === 0 && lastDirection === 'up' || currentScene === 0 && startText,
            'fade-down-out': previousScene === 0 && lastDirection === 'down',
            'in': currentScene === 0 && startedVideo
          }"
        >
          <div class="hero-scene__textbox1-text">
            Space with a whole new inspiration
          </div>
          <div class="hero-scene__textbox1-title">
            Utilize creative Media Art Solution to elevate the value of your space.
          </div>
        </div>

        <div class="hero-scene__artist">
          Moonwalker, curated by Artpoint
        </div>
        
        <!-- Scene 2 Text -->
        <div
          class="hero-scene__textbox2"
          :class="{
            'fade-up-in': currentScene === 1 && lastDirection === 'down',
            'fade-down-out': previousScene === 1 && lastDirection === 'up',
            'in': currentScene >= 1,
          }"
        >
          <!-- 'fade-down-out': previousScene === 1 && lastDirection === 'up' -->
          <div class="hero-scene__textbox2-title">
            Explore innovative Media Art Solution
            that combines our unrivaled signage with professional
            content technology.
          </div>
          <div class="hero-scene__textbox2-text">
            Subscribe our masterpieces or Build your own media art.
          </div>
        </div>
      </div>
    </div>

    <!-- About1 -->
    <div
      ref="about1"
      class="hero__scene-container hero__scene-container--3"
    >
      <div
        class="scene scene--3 about1"
        :class="{
          'slide-up-in': currentScene === 2 && lastDirection === 'down' && isMobile,
          'slide-down-out': previousScene === 2 && lastDirection === 'up' && isMobile
        }"
      >
        <div
          class="scene__col"
          :class="{ 
            'slide-down-in': currentScene === 2 && lastDirection === 'down' && isDesktop, 
            'slide-up-out': previousScene === 2 && lastDirection === 'up' && isDesktop 
          }"
        >
          <MotionBox />
        </div>
        <div
          class="scene__col"
          :class="{ 
            'slide-up-in': currentScene === 2 && lastDirection === 'down' && isDesktop, 
            'slide-down-out': previousScene === 2 && lastDirection === 'up' && isDesktop 
          }"
        >
          <div class="scene__textbox">
            <div class="scene__icon">
              <img
                src="/theme/rbFront/img/w/mediaArtSolution/icon_about01.png"
                alt=""
              >
            </div>
            <div class="scene__title">
              Content subscription service
            </div>
            <div class="scene__description">
              Enjoy a wide range of artistic pieces at<br class="br-desktop">
              a reasonable price.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- About2 -->
    <div
      ref="about2"
      class="hero__scene-container hero__scene-container--4"
    >
      <div
        class="scene scene--4 about2"
        :class="{
          'slide-up-in': currentScene === 3 && lastDirection === 'down' && isOutOfHeroSection === false && isMobile,
          'slide-down-out': previousScene === 3 && lastDirection === 'up' && isMobile
        }"
      >
        <div
          class="scene__col"
          :class="{ 
            'slide-down-in': currentScene === 3 && lastDirection === 'down' && isOutOfHeroSection === false && isDesktop, 
            'slide-up-out': previousScene === 3 && lastDirection === 'up' && isDesktop 
          }"
        >
          <div class="scene__textbox">
            <div class="scene__icon">
              <img
                src="/theme/rbFront/img/w/mediaArtSolution/icon_about02.png"
                alt=""
              >
            </div>
            <div class="scene__title">
              Tailored content creation
            </div>
            <div class="scene__description">
              Own your unique original content that<br class="br-desktop">
              perfectly fits your space. 
            </div>
          </div>
        </div>
        <div
          class="scene__col"
          :class="{ 
            'slide-up-in': currentScene === 3 && lastDirection === 'down' && isOutOfHeroSection === false && isDesktop, 
            'slide-down-out': previousScene === 3 && lastDirection === 'up' && isDesktop 
          }"
        >
          <img
            src="/theme/rbFront/img/w/mediaArtSolution/about02.jpg"
            alt=""
            class="scene__image"
          >
        </div>
      </div>
    </div>

    <div
      class="page-helper"
      :class="{'page-helper--white': currentScene > 1}"
      @click="handleClickPageHelper"
    >
      <div class="page-helper__text">
        {{ currentScene === 3 ? 'Our Collection' : 'Scroll Down' }}
      </div>
      <div class="page-helper__image">
        <img
          v-if="currentScene > 1"
          src="/theme/rbFront/img/w/mediaArtSolution/arrow_down2.png"
          alt=""
        >
        <img
          v-else
          src="/theme/rbFront/img/w/mediaArtSolution/arrow_down.png"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script>
import MotionBox from '../components/MotionBox.vue';
export default {
  name: 'SectionHero',
  components: {
    MotionBox
  },
  data() {
    return {
      scenes: [1, 2, 3, 4],
      currentScene: 0, // 현재 Scene 0: Hero, 1: Hero Text, 2: About1, 3: About2 
      previousScene: null,   // 이전 Scene 
      isScrolling: false, // 스크롤 진행 중 여부
      isWheeling: false, // 휠 진행 중 여부
      isAnimating: false, // 애니메이션 중 여부
      isHeroSection: true, // Hero Section인지 여부
      wheelTimeout: null, // 휠 디바운스
      scrollTimeout: null, // 스크롤 디바운스
			lastDirection: null, // 마지막 휠 방향
      totalLayerCount: 3, // 총 레이어 개수
      isOutOfHeroSection: false, // Hero Section 밖으로 나갔는지 여부
      shouldPreventWheel: false, // 휠 이벤트를 막을지 여부
      animationTime: 600, // Scene 전환 시간 (각 Scene 따라 변동 가능)
      heroSectionGap: 40, // Hero 섹션 시작 부분 Gap (Scroll Top 기준)
      touchStartY: null,
      touchMoveY: null,
      isTouching: false,
      touchThreshold: 50, // 터치 민감도 설정
      viewportWidth: window.innerWidth,
      // startVideo: false,
      startText: false,
      startedVideo: false,
      lastScrollTop: 0,
    }
  },
  computed: {
    isMobile() {
      return this.viewportWidth <= 1080;
    },
    isDesktop() {
      return this.viewportWidth > 1080;
    }
  },
  watch: {
    currentScene: {
      handler(newVal, oldVal) {
        this.$emit('change:scene', newVal, oldVal);
        console.log('change scene', newVal, oldVal);
        this.isAnimating = true;

        // 위에서 밑으로 이동할 때
        if (newVal > oldVal) {
          this.setLayerZindex(newVal, oldVal, 'down')
          setTimeout(() => {
            this.isAnimating = false;
          }, this.animationTime);
        } else {
          // 아래에서 위로 이동할 때
          setTimeout(() => {
            this.isAnimating = false;
            this.setLayerZindex(newVal, oldVal, 'up')
          }, this.animationTime);  
        }
      },
      immediate: false,
    },
    isOutOfHeroSection: {
      handler(newVal, oldVal) {
        // Hero Section밖에서 안으로 들어올 때
        if (newVal === false) {
          this.isAnimating = true;
          setTimeout(() => {
            this.isAnimating = false;
          }, this.animationTime);
        }
      },
      immediate: false,
    }
  },
  mounted() {
    window.addEventListener('load', this.handlePageLoaded);
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('wheel', this.handleWheel, { passive: false });
    window.addEventListener('touchstart', this.handleTouchStart, { passive: false });
    window.addEventListener('touchmove', this.handleTouchMove, { passive: false });
    window.addEventListener('touchend', this.handleTouchEnd, { passive: false });
    window.addEventListener('resize', this.handleResize)
    document.body.style.overscrollBehaviorY = 'none';
  },
  beforeUnmount() {
    window.removeEventListener('load', this.handlePageLoaded);
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('wheel', this.handleWheel);
    window.removeEventListener('touchstart', this.handleTouchStart);
    window.removeEventListener('touchmove', this.handleTouchMove);
    window.removeEventListener('touchend', this.handleTouchEnd);
    window.removeEventListener('resize', this.handleResize)
    document.body.style.overflow = 'auto';
    document.body.style.overscrollBehaviorY = 'auto';
  },
  methods: {
    handleLoadedVideo() {
      this.setupIntersectionObserver()
      console.log('handleLoadedVideo', this.getIsHeroSectionTop(), this.isHeroSection)
      
      // TODO: 비디오 로드 후, 비디오 재생 후 아래 코드 실행 
      setTimeout(() => {
        this.startText = true;
        setTimeout(() => {
          this.startedVideo = true;
        }, 1000);
      }, 300);
    },
    handlePageLoaded() {
      console.log('page loaded', this.getIsHeroSectionTop(), this.isHeroSection)
      requestAnimationFrame(() => {
        console.log('스크롤 복원 후 실행됨:', window.scrollY);
      })
      setTimeout(() => {
        // 최초 스크를 위치에 따른 설정
        if (this.getIsHeroSectionTop() && this.isHeroSection) {
          window.scrollTo(0, 0)
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = 'auto';
          this.currentScene = 3;
          this.isOutOfHeroSection = true;
          this.initReverseLayerZindex()
        }
        console.log('window.scrollY', window.scrollY);
      }, 500);
    },
    setupIntersectionObserver() {
      this.observer = new IntersectionObserver(this.handleIntersection, { threshold: [0, 0.1] });
      this.observer.observe(this.$refs.heroContainer);
    },
    setLayerZindex(current, previous, direction) {
      if (direction === 'down') {
        if (current === 2) {
          this.$refs.about1.style.zIndex = 4
        } else if (current === 3) {
          this.$refs.about2.style.zIndex = 5
        }
      } else {
        if (previous === 2) {
          this.$refs.about1.style.zIndex = 2
        } else if (previous === 3) {
          this.$refs.about2.style.zIndex = 1
        }
      }
    },
    initReverseLayerZindex() {
      setTimeout(() => {
        this.$refs.about1.style.zIndex = 4
        this.$refs.about2.style.zIndex = 5
      }, this.animationTime);
    },
    getIsHeroSectionTop() {
      return window.scrollY <= this.heroSectionGap ? true : false;
    },
    handleResize() {
      this.viewportWidth = window.innerWidth;
    },
    handleIntersection(entries) {
      const [entry] = entries;
      this.isHeroSection = entry.isIntersecting;
    },
    handleClickPageHelper() {
      if ( this.isWheeling || this.isAnimating) return;
      
      this.lastDirection = 'down'

      if (this.shouldPreventWheel) return;
      this.isWheeling = true;

      if (this.currentScene < 3) {
        this.previousScene = this.currentScene;
        this.currentScene++;
      } else {
        document.body.style.overflow = 'auto';
        this.isOutOfHeroSection = true;
        this.$emit('click:jumb');
      }
      // 스크롤 디바운스
      clearTimeout(this.wheelTimeout);
      this.wheelTimeout = setTimeout(() => {
        this.isWheeling = false;
      }, 500); 
    },
    handleWheel(e) {
      if (!this.isHeroSection || !this.getIsHeroSectionTop() || this.isWheeling || this.isAnimating) return;
      
      // 휠 방향 확인
      const direction = e.deltaY > 0 ? 'down' : 'up';
      this.lastDirection = direction
      
      if (this.shouldPreventWheel) return;
      this.isWheeling = true;
      
      if (direction === 'down') {
        if (this.currentScene < 3) {
          this.previousScene = this.currentScene;
          this.currentScene++;
        } else {
          document.body.style.overflow = 'auto';
          this.isOutOfHeroSection = true;
        }
      } else {
        if (this.currentScene > 0) {
          this.previousScene = this.currentScene;
          this.currentScene--;
        }
      }
			
      // 스크롤 디바운스
      clearTimeout(this.wheelTimeout);
      this.wheelTimeout = setTimeout(() => {
        this.isWheeling = false;
        console.log('휠 종료');
      }, 1400); 
    },
    handleTouchStart(e) {
      if (!this.isHeroSection || !this.getIsHeroSectionTop() || this.isAnimating) return;
      
      this.touchStartY = e.touches[0].clientY;
      this.isTouching = true;
    },
    handleTouchMove(e) {
      if (!this.isTouching || this.isAnimating) return;
      
      // e.preventDefault();
      this.touchMoveY = e.touches[0].clientY;
      
      // 터치 이동 거리 계산
      const touchDiff = this.touchStartY - this.touchMoveY;

      // 마지막 씬이고 아래로 스크롤하는 경우 실시간으로 스크롤 적용
      if (this.currentScene === 3 && touchDiff > 0 && this.isOutOfHeroSection) {
        document.body.style.overflow = 'auto';
        window.scrollTo({
          top: touchDiff + 100,
          behavior: 'smooth'
        });
        return;
      }
      
      // 터치 방향 확인 및 임계값 체크
      if (Math.abs(touchDiff) > this.touchThreshold) {
        const direction = touchDiff > 0 ? 'down' : 'up';
        this.handleTouchDirection(direction, touchDiff);
        
        // 터치 상태 초기화
        this.isTouching = false;
        this.touchStartY = null;
        this.touchMoveY = null;
      }
    },
    handleTouchEnd() {
      this.isTouching = false;
      this.touchStartY = null;
      this.touchMoveY = null;
    },
    handleTouchDirection(direction, touchDiff) {
      if (!this.isHeroSection || !this.getIsHeroSectionTop() || this.isAnimating) return;
      
      this.lastDirection = direction;
      
      if (this.shouldPreventWheel) return;
      
      console.log('touch change scene', this.currentScene, this.lastDirection);
      
      if (direction === 'down') {
        if (this.currentScene < 3) {
          this.previousScene = this.currentScene;
          this.currentScene++;
        } else {
          document.body.style.overflow = 'auto';
          this.isOutOfHeroSection = true;
          window.scrollTo({
            top: touchDiff + 100,
            behavior: 'smooth'
          });
        }
      } else {
        if (this.currentScene > 0) {
          this.previousScene = this.currentScene;
          this.currentScene--;
        }
      }
      
      // 터치 디바운스
      clearTimeout(this.wheelTimeout);
      this.wheelTimeout = setTimeout(() => {
        this.isWheeling = false;
      }, 800);
    },
    handleScroll() {
      console.log('scrolling', this.lastDirection)
      // Hero Section 밖에서 스크롤 시 마지막 방향 기억
      if (!this.getIsHeroSectionTop()) {
        let currentScrollTop = window.scrollY
        this.lastDirection = currentScrollTop > this.lastScrollTop ? 'down' : 'up'
        this.lastScrollTop = currentScrollTop
      }
      this.shouldPreventWheel = true
      if (this.getIsHeroSectionTop() && this.lastDirection === 'up') {
        this.isScrolling = true;
        window.scrollTo(0, 0)
        document.body.style.overflow = 'hidden';
        
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(() => {
          this.isScrolling = false;
          this.shouldPreventWheel = false
          this.isOutOfHeroSection = false;
        }, 500); 
      } else {
        clearTimeout(this.scrollTimeout);
          this.scrollTimeout = setTimeout(() => {
          this.shouldPreventWheel = false
          this.isScrolling = false;
        }, 500); 
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hero {
  position: relative;
  width: 100%;
  height: calc(100vh - 88px);
  box-sizing: border-box;
  overflow: hidden;
  &__scene {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 0.5s ease;
    &--active {
      opacity: 1;
    }
  }
  &__scene-container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    &--1 {
      z-index: 3;
      background-color: #000;
    }
    &--3 {
      z-index: 2;
    }
    &--4 {
      z-index: 1;
    }
  }
  @media screen and (max-width: 1080px) {
    height: calc(100vh - 54px);
  }
}

@keyframes scaleDown {
  0% {
    transform: scale(1.8) translateY(-10%);
  }
  50% {
    transform: scale(1) translateY(-0.01%);
  }
  60% {
    transform: scale(0.99) translateY(0%);
  }
  100% {
    transform: scale(1) translateY(0%);
  }
}
@keyframes fadeUpIn {
  0% {
    opacity: 0;
    transform: translate(-50%, 60%);
  }
  30% {  // 70% 지점까지 천천히 투명도 변화
    opacity: 0.3;
    transform: translate(-50%, 30%);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}
@keyframes fadeDownOut {
  0% {
    opacity: 1;
    transform: translate(-50%, 0);
  }
  50% {  // 70% 지점까지 천천히 투명도 변화
    opacity: 0.3;
    transform: translate(-50%, 30%);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, 60%);
  }
}
@keyframes slideDownIn {
  from {
    transform: translateY(-100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slideDownOut {
  from {
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(100%);
  }
}
@keyframes slideUpIn {
  from {
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slideUpOut {
  from {
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-100%);
  }
}

$scene: '.scene'; 
#{$scene} {
  display: flex;
  width: 100%;
  height: 100%;
  &.slide-up-in {
    animation: slideUpIn 0.6s ease-out forwards;
  }
  &.slide-down-out {
    animation: slideDownOut 0.6s ease-out forwards;
  }
  &__col {
    position: relative;
    width: 50%;
    height: 100%;
    overflow: hidden;
    flex: 1;
    background-color: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
    &.slide-up-in {
      animation: slideUpIn 0.6s ease-out forwards;
    }
    &.slide-down-in {
      animation: slideDownIn 0.6s ease-out forwards;
    }
    &.slide-up-out {
      animation: slideUpOut 0.6s ease-out forwards;
    }
    &.slide-down-out {
      animation: slideDownOut 0.6s ease-out forwards;
    }
  }
  &__textbox {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  &__title {
    font-size: 48px;
    font-weight: 600;
    line-height: 57.6px;
  }
  &__description {
    font-size: 24px;
    font-weight: 400;
    line-height: 31.2px;
    color: #666;
    text-align: center;
  }
  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  @media screen and (max-width: 1080px) {
    flex-direction: column;
    &__col {
      width: 100%;
      height: 50%;
    }
    &__textbox {
      width: 100%;
      gap: 12px;
      padding: 0 20px;
    }
    &__icon {
      width: 60px;
      height: 60px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    &__title {
      margin-top: 8px;
      font-size: 18px;
      line-height: 21.6px;
    }
    &__description {
      font-size: 16px;
      line-height: 20.8px;
    }
  }
}

.hero-scene {
  position: relative;
  &__video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    // transform: scale(1.8) translateY(-10%);
    &.scale-to-normal {
      animation: scaleDown 1.4s ease-out forwards; // 8초 동안 천천히 축소
    }
  }
  &__textbox1, &__textbox2 {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 100px;
    display: flex;
    flex-direction: column;
    max-width: 980px;
    opacity: 0;
    &.in {
      opacity: 1;
    }
    &.fade-up-in {
      animation: fadeUpIn 0.5s ease-in forwards;
    }
    &.fade-down-out {
      animation: fadeDownOut 0.9s ease-in forwards;
    }
  }
  &__textbox1 {
    gap: 12px;
  }
  &__textbox1-text {
    font-size: 24px;
    font-weight: 400;
    line-height: 31.68px;
    color: #fff;
    text-align: center;
  }
  &__textbox1-title {
    font-size: 64px;
    font-weight: 600;
    line-height: 76.8px;
    color: #fff;
    text-align: center;
  }
  &__textbox2 {
    gap: 12px;
  }
  &__textbox2-title {
    font-size: 48px;
    line-height: 57.6px;
    font-weight: 600;
    text-align: center;
    color: #fff;
  }
  &__textbox2-text {
    font-size: 24px;
    font-weight: 400;
    line-height: 31.2px;
    text-align: center;
    color: #fff;
  }
  &__artist {
    position: absolute;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    left: 28px;
    bottom: 28px;
  }
  @media screen and (max-width: 1080px) {
    &__textbox1, &__textbox2 {
      max-width: 100%;
      width: 100%;
      bottom: 110px;
      padding: 0 16px;
      box-sizing: border-box;
    }
    &__textbox1-text {
      font-size: 16px;
      line-height: 21.12px;
    }
    &__textbox1-title {
      font-size: 26px;
      line-height: 31.2px;
    }
    &__textbox2-title {
      font-size: 26px;
      line-height: 31.2px;
    }
    &__textbox2-text {
      font-size: 16px;
      line-height: 21.12px;
    }
  }
}

.about1 {
  @media screen and (max-width: 1080px) {
    flex-direction: column-reverse;
    #{$scene}__col {
      &:nth-child(1) {
        flex: 6;
      }
      &:nth-child(2) {
        flex: 4;
      }
    }
  }
}
.about2 {
  @media screen and (max-width: 1080px) {
    #{$scene}__col {
      &:nth-child(1) {
        flex: 4;
      }
      &:nth-child(2) {
        flex: 6;
      }
    }
  }
}

.page-helper {
  position: absolute;
  left: 50%;
  bottom: 24px;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  height: 44px;
  background-color: #fff;
  border-radius: 999px;
  gap: 6px;
  cursor: pointer;
  &__text {
    font-size: 18px;
    font-weight: 600;
    line-height: 19.8px;
    text-align: center;
    color: #000;
  }
  &__image {
    width: 15px;
    height: 15px;
    transform: translateY(-2px);
    img {
      width: 100%;
      height: 100%;
    }
  }
  &--white {
    background-color: #000;
    .page-helper__text {
      color: #fff;
    }
  }
  @media screen and (max-width: 1080px) {
    display: none;
  }
}
</style>